module.exports = __webpack_public_path__ + "static/media/listing.e9d4a945.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/listing.jpg
// module id = 1414
// module chunks = 1